export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">移动阅读</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              亲亲漫画网完美适配手机、平板等移动设备，随时随地享受<strong className="text-foreground-900">下拉式漫画阅读</strong>的畅快体验。无需下载APP，浏览器打开即可阅读，支持添加到桌面快捷方式，一键直达你的漫画世界。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                <span className="text-xs text-foreground-600">手机适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <i className="ri-tablet-line text-accent-500 text-lg"></i>
                <span className="text-xs text-foreground-600">平板适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <i className="ri-cloud-line text-secondary-500 text-lg"></i>
                <span className="text-xs text-foreground-600">无需下载</span>
              </div>
            </div>
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer text-sm"
            >
              <i className="ri-play-circle-line text-lg"></i>
              立即体验
            </a>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[360px]">
              <div className="aspect-[9/16] rounded-2xl overflow-hidden border-[6px] border-foreground-900/80 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20page%20in%20vertical%20scroll%20reading%20mode%2C%20clean%20UI%20interface%2C%20warm%20orange%20and%20cream%20color%20scheme%2C%20minimal%20app%20design%2C%20product%20mockup%20style%2C%20soft%20lighting&width=720&height=1280&seq=app-mobile-manga&orientation=portrait"
                  alt="亲亲漫画网移动端下拉式阅读体验"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}